//import './bootstrap';
import * as Sentry from "@sentry/browser";
import '../../vendor/masmerise/livewire-toaster/resources/js'; // 👈


import Vapor from 'laravel-vapor'
window.Vapor = Vapor